import React from "react";
import { Triangle } from "react-loader-spinner";
import { useLoading } from "../contexts/LoadingContext";
import "./loader.css";

const Loader = () => {
  const { isLoading } = useLoading();

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader-blur" />
          <Triangle
            height="180"
            width="180"
            color="#c84f92"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )}
    </>
  );
};

export default Loader;
